import {createSlice} from '@reduxjs/toolkit'
import {
  fetchAccounts,
  fetchMyAccounts,
  fetchSubscriptions,
} from './accountsThunk'

const initialState = {
  accounts: {
    results: [],
    loading: false,
    error: null,
  },
  subscriptions: {
    results: [],
    loading: false,
    error: null,
  },
  myAccounts: {
    results: [],
    total: null,
    offset: 0,
    limit: 20,
    loading: false,
    error: null,
  },
}

const accountsSlice = createSlice({
  name: 'accounts',
  initialState,
  reducers: {
    resetAccounts: state => {
      state.accounts.results = []
      state.accounts.loading = false
      state.accounts.error = null
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchAccounts.pending, state => {
        state.accounts.loading = true
        state.accounts.error = null
        state.accounts.results = []
      })
      .addCase(fetchAccounts.fulfilled, (state, action) => {
        state.accounts.loading = false
        state.accounts.error = null
        state.accounts.results = action.payload
      })
      .addCase(fetchAccounts.rejected, (state, action) => {
        state.accounts.loading = false
        state.accounts.error = action.payload ?? 'Failed to fetch accounts'
        state.accounts.results = []
      })
      .addCase(fetchSubscriptions.pending, state => {
        state.subscriptions.loading = true
        state.subscriptions.error = null
        state.subscriptions.results = []
      })
      .addCase(fetchSubscriptions.fulfilled, (state, action) => {
        state.subscriptions.loading = false
        state.subscriptions.error = null
        state.subscriptions.results = action.payload
      })
      .addCase(fetchSubscriptions.rejected, (state, action) => {
        state.subscriptions.loading = false
        state.subscriptions.error =
          action.error.message ?? 'Failed to fetch subscriptions'
        state.subscriptions.results = []
      })
      .addCase(fetchMyAccounts.pending, state => {
        state.myAccounts.loading = true
        state.myAccounts.error = null
        state.myAccounts.results = []
      })
      .addCase(fetchMyAccounts.fulfilled, (state, action) => {
        state.myAccounts.loading = false
        state.myAccounts.error = null
        state.myAccounts.results = action.payload?.accounts ?? []
        // total is only recomputed on the first page (offset 0); the backend
        // returns null on later pages, so keep the count we already have.
        if (action.payload?.total != null) {
          state.myAccounts.total = action.payload.total
        }
        if (action.payload?.offset != null) {
          state.myAccounts.offset = action.payload.offset
        }
        if (action.payload?.limit != null) {
          state.myAccounts.limit = action.payload.limit
        }
      })
      .addCase(fetchMyAccounts.rejected, (state, action) => {
        state.myAccounts.loading = false
        state.myAccounts.error =
          action.error.message ?? 'Failed to fetch accounts'
        state.myAccounts.results = []
      })
  },
})

export const {resetAccounts} = accountsSlice.actions

export default accountsSlice.reducer
